import styled from 'styled-components';
export const WrapperReceipt = styled.div`
  .page {
    position: relative;
    background: white;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.5cm;
    width: 14cm;
    // height: 29.7cm;
    page-break-after: always;
    &:not(:first-child) {
      padding-top: 34px;
    }
  }
  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-2 {
    flex: 2 !important;
  }
  .justify-content-between {
    justify-content: space-between;
  }
  .align-items-center {
    align-items: center;
  }
  .label {
    margin-left: 5px;
  }
  .bold {
    font-weight: bold;
  }
  .numbers {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin: 5px 0;
  }
  .card-b_content-row {
    page-break-inside: avoid
  }
  .address-box {
    margin-right: 100px;
    span {
      font-size: 12px
    }
  }

  .logo-box {
    // margin: auto;
    // padding: 38px 0 0;
    padding-right: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 120px;
      margin-bottom: 10px;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .card-a {
    margin-bottom: 10px;
    &_box {
      display: flex;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 15px;
    }
    &_item {
      flex: 1;
      text-align: center;
      border-right: 1px dashed #ddd;
      &:first-child {
        border-right: none;
      }
    }
    &_label {
      color: #ccc;
    }
    &_text {
      font-weight: bold;
    }
  }
  .card-b {
    page-break-after: avoid;
    width: 100%;
    &_box {
      display: flex;
      flex-direction: column;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 15px;
    }
    &_header {
      display: flex;
      flex: 1;
      &-box {
        padding: 0 0 5px 0;
        border-bottom: 2px solid #ddd;
        margin-bottom: 5px;
      }
      &-item {
        flex: 1;
        text-align: center;
        border-right: 1px dashed #ddd;
        padding: 5px 0;
        &:first-child {
          border-right: none;
        }
        &:nth-child(2) {
          flex: 3;
        }
        &:last-child {
          flex: 4;
        }
      }
    }
    &_content {
      display: flex;
      flex: 1;
      flex-direction: column;
      &-row {
        display: flex;
        flex: 1;
        margin: 3px 0;
        padding: 3px 0;
        border-bottom: 1px solid #ddd;
        &:last-child {
          border-bottom: none;
          margin: 0;
          page-break-after: avoid
        }
      }
      &-item {
        flex: 1;
        text-align: center;
        border-right: 1px dashed #ddd;
        padding: 5px 0;
        &:first-child {
          border-right: none;
        }
         &:nth-child(2) {
          flex: 3;
        }
        &:last-child {
          flex: 4;
        }
      }
    }
  }

  .description {
    min-height: 100px;
    border: 2px solid #ddd;
    border-radius: 15px;
  }
  .sing-box {
    display: flex;
    justify-content: space-between;
    position: absolute;
    padding: 59px 30px;
    bottom: 0;
    left: 0;
    right: 0;
    .item {
      display: flex;
      flex-direction: column;
    }
  }

  @media print {
    body {
      width: 21cm;
      // margin: 10mm 20mm 10mm 20mm;
      /* change the margins as you want them to be. */
    }
    .page {
      width: 21cm;
      padding-top: 20px;
      // margin-right: -65px;
      // margin-top: -65px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      page-break-after: always;
      &:not(:first-child) {
        padding-top: 44px;
      }
    }
  }
`;
